<script>
import api from '../helper/api';

export default {
    data() {
        return {
            model: null,
            validation: {}
        }
    },
    created() {
        if(this.model) {
            this.$store.dispatch('validation/loadRules', this.model).then(rules => {
                this.validation = rules;
            });
        }
    },
    methods: {
        validationRule(field) {
            return field in this.validation ? this.validation[field] : '';
        }
    }
}
</script>